import IFilterSection from "../interfaces/IFilterSection";
import {Dispatch} from "redux";

export default async function(_dispatch?: Dispatch): Promise<IFilterSection[]> {
  return [
  ]
}
